import axios from 'axios';

const baseURL = process.env.REACT_APP_APIURL;

/**
 * Local replacement for Amplify Storage.put()
 * Uploads a file to the local backend server instead of S3.
 */
export async function localStoragePut(
  key: string,
  file: Blob | File,
  options?: { level?: string; contentType?: string; progressCallback?: (progress: { loaded: number; total: number }) => void }
) {
  await axios.put(`${baseURL}/uploads/${key}`, file, {
    headers: { 'Content-Type': (options?.contentType) || (file as File).type || 'application/octet-stream' },
    onUploadProgress: options?.progressCallback
      ? (progressEvent: any) => {
          options.progressCallback!({ loaded: progressEvent.loaded, total: progressEvent.total });
        }
      : undefined,
  });
  return { key };
}

/**
 * Local replacement for Amplify Storage.get()
 * Returns a direct URL to the locally stored file.
 */
export function localStorageGet(key: string, _options?: any): Promise<string> {
  return Promise.resolve(`${baseURL}/uploads/${key}`);
}
